export default function Hero() {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/76b1a1a0859ed779766519171c4713f1.jpg"
          alt="레이저 가공 장비"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/70"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          레이저 가공 전문 뉴테크
        </h1>
        <p className="text-xl md:text-2xl mb-8 opacity-95">
          정밀한 레이저 커팅 & 마킹 서비스
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="tel:02-2261-2017"
            className="inline-flex items-center gap-2 px-8 py-4 bg-amber-500 text-slate-900 text-lg font-bold rounded-lg hover:bg-amber-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            02-2261-2017
          </a>
          <a
            href="mailto:nt2017@daum.net"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-slate-900 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-fill text-xl"></i>
            이메일 문의
          </a>
        </div>
      </div>
    </section>
  );
}
